import { render } from "./FacturadorFillPOSView.vue?vue&type=template&id=72c6ec5a&scoped=true"
import script from "./FacturadorFillPOSView.vue?vue&type=script&lang=js"
export * from "./FacturadorFillPOSView.vue?vue&type=script&lang=js"

import "./FacturadorFillPOSView.vue?vue&type=style&index=0&id=72c6ec5a&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c6ec5a"]])

export default __exports__